module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/3-677e85b1bfacd90b041d799cd004f61a.jpg";